module.exports = __webpack_public_path__ + "static/media/01d.152085b3.png";